import { sidebarActionTypes } from '@/router/store/sidebar.types';

export const setSidebar = (isOpen: boolean) => ({
  type: sidebarActionTypes.SET_SIDEBAR,
  isOpen,
});
